import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import PricingContent from "../../components/Popups/Pricing/PricingContent/PricingContent.tsx";
import Header from "../../layout/HeaderLayout/HubHeader/HubHeader.tsx";
import styles from "./Pricing.module.scss";

const PricingPage = () => {
	return (
		<>
			<Header />
			<Box className={styles.pricingPageContainer}>
				<PricingContent isPublicPage={true} />
			</Box>
		</>
	);
};

export default observer(PricingPage);
